import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import Grid from 'material-ui/Grid'
import Divider from 'material-ui/Divider'
import _ from 'lodash'

import { getDeposits } from 'modules/users/current/deposits'
import parametersSelector from 'selectors/parameters'
import jsonSelector from 'selectors/json'

const currency_format = config_parameters => value =>
  `${I18n.l(value, { maximumFractionDigits: config_parameters['coin.currency_precision'] })}`

const UserBalances = ({ currency_format, user_signed_in, user_balances, abilities }) => (
  <Grid container id="sidebar-user-balances">
    {!_.isEmpty(user_balances) && [
      <Grid key="ub-bottom" item xs={12} sm={12} md={12}>
        <h4>{I18n.t('aside.deposits')}</h4>
        {_.map(user_balances, (balance, currency) => (
          <p key={currency}>
            {currency}: {currency_format(balance)}
          </p>
        ))}
      </Grid>,
      <Grid key="ci-0" item xs={12}>
        <Divider light />
      </Grid>
    ]}
  </Grid>
)

class UserBalancesContainer extends Component {
  componentDidMount() {
    const { getDeposits, user_signed_in } = this.props
    user_signed_in && getDeposits()
  }

  render() {
    if (!this.props.user_signed_in) return null
    return <UserBalances {...this.props} />
  }
}

const mapStateToProps = state => ({
  user_signed_in: !!state.users.authorization,
  currency_format: currency_format(parametersSelector(state)),
  user_balances: jsonSelector('users.current.deposits')(state),
  abilities: jsonSelector('infos.abilities')(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({ getDeposits }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(UserBalancesContainer)



// WEBPACK FOOTER //
// ./src/containers/pages/dashboard/user_balances.js